// extracted by mini-css-extract-plugin
export default {"creatable-react-select":"style_creatable-react-select__31Td+"};